import { PAGE_INFO_FIELDS } from "@/graphql/pagination";
import gql from "graphql-tag";

import { ORGANISATION_STOCK_ITEM_FIELDS, STOCK_BASKET_FIELDS } from "../shared";

export const ORGANISATION_STOCK_LIST_QUERY = gql`
  query OrganisationStockListQuery(
    $organisation: ID!
    $page: Int
    $orderBy: String
    $search: String
    $filter: String
  ) {
    organisationStockPagination(
      organisation: $organisation
      page: $page
      orderBy: $orderBy
      search: $search
      filter: $filter
    ) {
      items {
        id
        expiryDate
        testProduct {
          id
          paymentIsoCode
          organisation
          name
          providerApi
        }
        createdFromOrder {
          id
          checkoutDate
        }
        testProductOption {
          id
          paymentIsoCode
          organisation
        }
        orderTestItem {
          id
          providerTestId
        }
        registeredUserFullName
        omnosBarcodeId
        registeredOrder {
          id
        }
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${PAGE_INFO_FIELDS}
`;

export const ORGANISATION_STOCK_DETAILS_QUERY = gql`
  query OrganisationStockDetailsQuery($id: ID!, $organisation: ID!) {
    organisationStockItem(id: $id, organisation: $organisation) {
      ...OrganisationStockItemFields
    }
  }
  ${ORGANISATION_STOCK_ITEM_FIELDS}
`;

export const ORGANISATION_STOCK_BASKET_QUERY = gql`
  query OrganisationStockBasketQuery($stockId: ID!, $organisation: ID!) {
    stockBasket(stockId: $stockId, organisation: $organisation) {
      ...StockBasketFields
    }
  }
  ${STOCK_BASKET_FIELDS}
`;
